import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './PanelHeader.css';

const PanelHeader = ({ title = 'Menu', onClose }) => {
  return (
    <div className="mobile-panel-header">
      <span className="mobile-panel-header-title">{title}</span>
      <button
        type="button"
        className="mobile-panel-close"
        onClick={onClose}
        aria-label="Close menu"
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
};

export default PanelHeader;
